export const getCurrencyUnit = (storeID) => {
  switch (storeID) {
    case '1':
    case '3':
    case '4':
      return 'kr'
    case '5':
    case '6':
    case '7':
    case '10':
    case '11':
    case '12':
    case '14':
    case '15':
    case '18':
    case '21':
    case '23':
    case '24':
    case '26':
      return '€'
    case '8':
      return '£'
    case '9':
      return 'Kč'
    case '16':
      return 'zł'
    case '17':
      return 'Ft'
    case '19':
    case '20':
      return 'CHF'
    case '22':
      return 'лв.'
    case '25':
      return 'Lei'
    case '27':
    case '28':
    case '32':
    case '36':
      return '$'
    case '29':
      return 'SGD'
    case '31':
      return 'R'
    case '33':
      return 'CAD $'
    case '34':
      return '$ CAD'
    case '44':
      return '원'
    default:
      return ''
  }
}

